import { useState, useEffect } from 'react';
// @ts-ignore - The pkg folder is generated dynamically after cargo build
import initWasm, { initialize_index, prefix_search } from './menu-search/pkg/menu_search.js';

export interface SearchResult {
  title: string;
  route: string;
}

export function useWasmMenuSearch() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    async function setupSearch() {
      // Initialize compiled WASM. We pass the public URL of the wasm binary.
      await initWasm('/menu_search_bg.wasm');

      // Fetch the JSON menu dataset
      const response = await fetch('/menu_data.json');
      const menuData = await response.text();

      // Load data into Rust memory to build FST index
      initialize_index(menuData);
      setReady(true);
    }

    setupSearch().catch(err => {
      console.error("WASM Search init crashed:", err);
    });
  }, []);

  const executeSearch = (query: string): SearchResult[] => {
    if (!ready || !query.trim()) return [];
    
    // Calls directly into compiled Rust via WebAssembly pointers
    const rawJsonString = prefix_search(query);
    if (!rawJsonString) return [];
    
    try {
      return JSON.parse(rawJsonString) as SearchResult[];
    } catch (e) {
      console.error("Failed to parse search results:", e);
      return [];
    }
  };

  return { executeSearch, ready };
}
